export default "__VITE_ASSET__C2Hd5Gmy__"